// extracted by mini-css-extract-plugin
module.exports = {"container":"bj_x","eyebrow":"bj_H","title":"bj_S","content":"bj_y","rightColumn":"bj_dc"};